/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BoxLineItem
 */
export interface BoxLineItem {
    /**
     * 商品 id
     * @type {number}
     * @memberof BoxLineItem
     */
    goodsId: number;
    /**
     * SKU id；未传时保存前按 goods.sku_id 回填
     * @type {number}
     * @memberof BoxLineItem
     */
    skuId?: number;
    /**
     * 数量
     * @type {number}
     * @memberof BoxLineItem
     */
    quantity: number;
}

/**
 * Check if a given object implements the BoxLineItem interface.
 */
export function instanceOfBoxLineItem(value: object): value is BoxLineItem {
    if (!('goodsId' in value) || value['goodsId'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    return true;
}

export function BoxLineItemFromJSON(json: any): BoxLineItem {
    return BoxLineItemFromJSONTyped(json, false);
}

export function BoxLineItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): BoxLineItem {
    if (json == null) {
        return json;
    }
    return {
        
        'goodsId': json['goodsId'],
        'skuId': json['skuId'] == null ? undefined : json['skuId'],
        'quantity': json['quantity'],
    };
}

export function BoxLineItemToJSON(json: any): BoxLineItem {
    return BoxLineItemToJSONTyped(json, false);
}

export function BoxLineItemToJSONTyped(value?: BoxLineItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'goodsId': value['goodsId'],
        'skuId': value['skuId'],
        'quantity': value['quantity'],
    };
}

